// extracted by mini-css-extract-plugin
module.exports = {"layout_1:4_1:2_1:4":"_3AGaGi","fillPageWidth":"_1NBTdK"};